import { render, staticRenderFns } from "./formGeneralDataAndRisks.vue?vue&type=template&id=d4b60484&"
import script from "./formGeneralDataAndRisks.vue?vue&type=script&lang=js&"
export * from "./formGeneralDataAndRisks.vue?vue&type=script&lang=js&"
import style0 from "./formGeneralDataAndRisks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports